<template>
  <div id="app">
    <template v-if="currentUser">
      <nav class="navbar" role="navigation" aria-label="main navigation">
        <div class="navbar-brand header">
          <div>
            <a class="navbar-item" href="/">
              <img src="./assets/ppyatc.jpg" alt="Insurance Submit System" width="50" height="50">
            </a>
          </div>

          <div class="navbar-item">
            <template v-if="currentUser.isAdmin">
              <button class="button is-small is-danger" @click="goSetting">
                <b-icon icon="cogs" size="is-small"></b-icon>&nbsp; Setup
              </button>
            </template>
          </div>
          <div class="navbar-item">
            <button class="button is-small is-link" @click="goDownload">
              <b-icon icon="download" size="is-small"></b-icon>&nbsp;Download
            </button>
          </div>
          <div class="navbar-item">
            <button class="button is-small is-info" @click="signOut">
              <b-icon icon="logout" size="is-small"></b-icon>&nbsp; Logout
            </button>
          </div>
        </div>
      </nav>
    </template>
    <router-view/>
  </div>
</template>

<script>
import db from "@/db";
export default {
  computed: {
    currentUser() {
      return this.$store.state.currentUser;
    }
  },
  methods: {
    goSetting() {
      this.$router.push("setting");
    },
    goDownload() {
      this.$router.push("download");
    },
    signOut() {
      db.signOut().then(() => this.$router.replace("login"));
    }
  }
};
</script>

<style lang="scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  .tab-item .is-primary {
    margin-right: 5px;
  }
  .field .label {
    text-align: left;
  }
}
.header {
  display: flex;
  justify-content: space-between;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.row-approve-bg {
  // background: green !important;
  color: red;
}
</style>
